"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Legend } from "recharts";
import clsx from "clsx";
const LegendContent = ({ payload, className }) => {
    if (!payload || payload.length === 0) {
        return null;
    }
    return (_jsx("div", { className: clsx("flex flex-wrap items-center gap-x-4 gap-y-2 text-xs", className), children: payload.map((entry) => (_jsxs("span", { className: "flex items-center gap-2 text-[var(--chart-axis-color)]", children: [_jsx("span", { className: "h-2 w-2 rounded-sm", style: { backgroundColor: entry.color } }), _jsx("span", { className: "font-medium", children: entry.value })] }, String(entry.value)))) }));
};
export function ChartLegend({ className, ...props }) {
    return _jsx(Legend, { ...props, content: legendProps => _jsx(LegendContent, { ...legendProps, className: className }) });
}
